import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-book-receipt-monthwise',
  templateUrl: './book-receipt-monthwise.component.html',
  styleUrls: ['./book-receipt-monthwise.component.scss'],
})
export class BookReceiptMonthwiseComponent {
  PaymentBookOffInDFormBenas: any[] = [];
  startDate: string = '';
  endDate: string = '';
  currentDate = new Date();
  reportType = 'Monthwise';
  officerepwise: any;
  repName: any;
  loading = false;

  // Table-related
  monthList: string[] = [];
  monthwiseData: any[] = [];
  monthTotals: any = {};
  overallTotal: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<BookReceiptMonthwiseComponent>,
    private service: DigisubservicesService
  ) {}

  ngOnInit(): void {
    debugger
    console.log('Dialog Data:', this.data);

    this.startDate = this.data?.start_date || this.data?.startDate || '';
    this.endDate = this.data?.end_date || this.data?.endDate || '';
    this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || '';
    this.repName = this.data?.rep_name || this.data?.repName || '';

    if (!this.startDate || !this.endDate) {
      console.warn('⚠️ Missing start_date or end_date');
      return;
    }

    this.getReportData();
  }

  // ✅ Fetch Data from API
  getReportData(): void {
    this.loading = true;

    const payload = {
      start_date: this.startDate,
      end_date: this.endDate,
      office_rep_name: this.officerepwise,
      rep_name: this.repName,
    };

    this.service.getBookPaymentRegiOffInDetails2(payload).subscribe({
      next: (res: any) => {
        //  this.paymentBookOffInDFormBeans=res 
        console.log('✅ API Response:', res);
        this.PaymentBookOffInDFormBenas = res || [];
        this.prepareMonthwiseData();
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ Error:', err);
        this.loading = false;
      },
    });
  }

  // ✅ Prepare data for table display
 prepareMonthwiseData() {
  const repMap: any = {};
  const allMonthsSet = new Set<string>();

  // Define month order for sorting
  const monthOrder: { [key: string]: number } = {
    'January': 1, 'February': 2, 'March': 3, 'April': 4,
    'May': 5, 'June': 6, 'July': 7, 'August': 8,
    'September': 9, 'October': 10, 'November': 11, 'December': 12
  };

  for (let office of this.PaymentBookOffInDFormBenas) {
    const repName = office.office_rep_name || 'Unknown Rep';
    if (!repMap[repName]) repMap[repName] = { office_rep_name: repName };

    for (let yearData of office.yearly_data || []) {
      for (let m of yearData.months || []) {
        const month = m.month;
        const receipt = parseFloat(m.total_receipt) || 0;
        allMonthsSet.add(month);

        repMap[repName][month] = (repMap[repName][month] || 0) + receipt;
      }
    }

    // Total for each rep
    repMap[repName]['Total'] = office.total_office_rcv || 0;
  }

  // Sort months in chronological order
  this.monthList = Array.from(allMonthsSet).sort((a, b) => {
    return (monthOrder[a] || 0) - (monthOrder[b] || 0);
  });

  this.monthwiseData = Object.values(repMap);
  this.calculateMonthwiseTotals();
}

  // ✅ Calculate totals
  calculateMonthwiseTotals() {
    this.monthTotals = {};
    this.overallTotal = 0;

    for (let month of this.monthList) {
      let total = 0;
      for (let data of this.monthwiseData) {
        total += data[month] || 0;
      }
      this.monthTotals[month] = total;
      this.overallTotal += total;
    }
  }

  // ✅ Row total
  getRowTotal(row: any): number {
    let total = 0;
    for (let month of this.monthList) {
      total += row[month] || 0;
    }
    return total;
  }

  // ✅ Print Function
 printPage4() {
  const printContent = document.getElementById('print-section');
  const WindowPrt = window.open('', '', 'width=1400,height=900');

  WindowPrt.document.write(`
    <html>
      <head>
        <title>Book Payment Monthwise Report</title>
        <style>

          /* ========== FORCE COLORS IN PRINT ========== */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          @page {
            size: A3 landscape;
            margin: 5mm;
          }

          body {
            font-family: Arial, sans-serif;
            font-size: 15px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
          }

          th, td {
            border: 1px solid black;
            padding: 6px;
            text-align: right;
          }

          /* Header color */
          thead th {
            background-color: #dfe6e9 !important;
            text-align: center;
            font-size: 17px;
          }

          /* Footer Total Row */
          tfoot tr {
           background-color: #c8753f !important;
            font-weight: bold;
          }

          .noPrint {
            display: none !important;
          }

        </style>
      </head>
      <body>${printContent?.innerHTML}</body>
    </html>
  `);

  WindowPrt.document.close();
  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 700);
}
exportExcel(fileName): void {
      console.log('Export function called with fileName:', fileName);
  
      let element = document.getElementById('print-section');
      console.log('Element found:', element);
  
      if (!element) {
        console.error('Element with ID "print-section" not found in DOM');
        return;
      }
  
      try {
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
        console.log('Worksheet created:', ws);
  
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
        XLSX.writeFile(wb, fileName + '.xlsx');
        console.log('File should be downloaded');
      } catch (error) {
        console.error('Error during export:', error);
      }
    }

}
